import React, { useState } from 'react';


function ContactForm({ onSubmit }) {
    const [name, setName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [email, setEmail] = useState('');
  
    const handleSubmit = (event) => {
      event.preventDefault();
      onSubmit({ name, lastName, phoneNumber, email });
    };
  
    const inputStyle = {
      padding: '10px',
      borderRadius: '5px',
      border: '1px solid #ccc',
      boxShadow: '2px 2px 5px rgba(0,0,0,0.1)',
      width: '100%',
      boxSizing: 'border-box',
      marginBottom: '10px'
    };
  
    return (
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', margin: '10px auto 0 auto', maxWidth: '600px', borderRadius: '10px', padding: '20px', backgroundColor: '#e3e7ee' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', marginRight: '10px', flex: 1 }}>
            <label style={{ marginBottom: '5px' }}>
              Namn:
            </label>
            <input type="text" placeholder="Name" value={name} onChange={e => setName(e.target.value)} required style={inputStyle} autoComplete="given-name" />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            <label style={{ marginBottom: '5px' }}>
              Efternamn:
            </label>
            <input type="text" placeholder="Last Name" value={lastName} onChange={e => setLastName(e.target.value)} required style={inputStyle} autoComplete="family-name" />
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '5px' }}>
          <label style={{ marginBottom: '5px' }}>
            Telefonnummer:
          </label>
          <input type="tel" placeholder="Phone Number" value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} required style={inputStyle} autoComplete="tel" />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '5px' }}>
          <label style={{ marginBottom: '5px' }}>
            Epost:
          </label>
          <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required style={inputStyle} autoComplete="email" />
        </div>
        <button type="submit" style={{ padding: '10px', borderRadius: '5px', border: 'none', backgroundColor: '0062ad', color: 'white', cursor: 'pointer' }}>Submit</button>
      </form>
    );
  }
  export default ContactForm;